import { render, staticRenderFns } from "./ScrollMenu.vue?vue&type=template&id=465d02ab&scoped=true"
import script from "./ScrollMenu.vue?vue&type=script&lang=js"
export * from "./ScrollMenu.vue?vue&type=script&lang=js"
import style0 from "./ScrollMenu.vue?vue&type=style&index=0&id=465d02ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465d02ab",
  null
  
)

export default component.exports